import { render, staticRenderFns } from "./PublicLayoutHeader.vue?vue&type=template&id=4964e9c2&scoped=true"
import script from "./PublicLayoutHeader.vue?vue&type=script&lang=js"
export * from "./PublicLayoutHeader.vue?vue&type=script&lang=js"
import style0 from "./PublicLayoutHeader.vue?vue&type=style&index=0&id=4964e9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4964e9c2",
  null
  
)

export default component.exports